module.exports = __webpack_public_path__ + "assets/fonts/segoeui-semibold-66d11e55b7a413ddf6a84e858697e7b6.woff2";